import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, ButtonBar, Icon } from '../../../../common/components';
import { Row, Col, InputGroup, FormControl, FormGroup, Grid } from 'react-bootstrap';
import { Form, Field, reduxForm } from 'redux-form';
import '../../../brochure/brochure.scss';
import './LoginForm.scss';

const InputGroupAddon = InputGroup.Addon;

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
};

class LoginForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  renderEmailField(field) {
    const { input } = field;
    return (
      <FormGroup>
        <Col sm={12}>
          <InputGroup>
            <InputGroupAddon>
              <Icon name="envelope" />
            </InputGroupAddon>
            <FormControl {...input} type="email" placeholder="Email address" />
          </InputGroup>
        </Col>
      </FormGroup>
    );
  }

  renderPasswordField(field) {
    const { input } = field;
    return (
      <FormGroup>
        <Col sm={12}>
          <InputGroup>
            <InputGroupAddon>
              <Icon name="lock" />
            </InputGroupAddon>
            <FormControl {...input} type="password" placeholder="Password" />
          </InputGroup>
        </Col>
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, submitting, error } = this.props;
    const b2bUrl = window['__B2B_URL__'];

    return (
      <>
        <Grid>
          <Row className="login-row" sm={12} md={12}>
            <Col className="login-column" sm={12} md={6}>
              <div className="login-box">
                <div className="head">
                  <h2>Just Travel B2B Login</h2>
                </div>
                <Box className="container-fluid">
                  <Form onSubmit={handleSubmit} className="login-form" method="post">
                    <Field id="email" name="email" component={this.renderEmailField}/>
                    <Field id="password" name="password"
                           component={this.renderPasswordField}/>
                    <Row>
                      <Col sm={12}>
                        <ButtonBar>
                          <Button
                            id="login-button"
                            type="submit"
                            className="pull-right"
                            bsStyle="primary"
                            disabled={submitting}
                          >
                            {submitting ? (
                              <i className="fa fa-cog fa-spin"/>
                            ) : (
                              <i className="fa fa-sign-in"/>
                            )}{' '}
                            login
                          </Button>
                          <Button
                            link
                            className="pull-right"
                            bsStyle="default"
                            label="forgotten password?"
                            to="/password/remind"
                          />
                        </ButtonBar>
                      </Col>
                    </Row>
                  </Form>
                </Box>
                {error && (
                  <Row>
                    <Col sm={12}>
                      <div className="invalid-error">
                        <strong>{error}</strong>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </Col>
            <Col className="login-column" sm={12} md={6}>
              <div className={'aneevo-login-box'}>
                <div className={'head'}>
                  <img
                    src={require('../../../../images/brand/aneevo.jpeg')}
                    alt="just-travel"
                  />
                </div>
                <div className={'body'}>
                  <div className={'broker-text'}>
                    Broker Partners: To access Aneevo, please click here or visit <a
                    href="https://admin.aneevo.com">admin.aneevo.com </a>
                  </div>
                  <div className={'login-trouble-text'}>&nbsp;</div>
                  <div className={'aneevo-icon'}>
                    <a href={b2bUrl}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        {/* Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. */}
                        <path
                          d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>

      </>
    );
  }
}

export default reduxForm({
  form: 'login',
  validate,
})(LoginForm);
